import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Pizza, Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FFF8E7] flex items-center justify-center p-4">
      <div className="pizza-card p-6 sm:p-8 w-full max-w-sm" data-testid="forgot-password-card">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-[#FFC107] rounded-full border-2 border-[#2A2A2A] flex items-center justify-center mx-auto mb-3 shadow-[3px_3px_0px_0px_rgba(42,42,42,1)]">
            <Mail className="w-7 h-7 text-[#2A2A2A]" />
          </div>
          <h1 className="text-3xl text-[#2A2A2A]" style={{ fontFamily: "'Bebas Neue', cursive" }} data-testid="forgot-title">
            Forgot Password?
          </h1>
          <p className="text-sm text-[#2A2A2A]/50 mt-1">No worries. Enter your email and we'll send a reset link.</p>
        </div>

        {sent ? (
          <div className="text-center" data-testid="forgot-success">
            <CheckCircle className="w-12 h-12 text-[#2E7D32] mx-auto mb-3" />
            <h2 className="text-xl text-[#2A2A2A] mb-2" style={{ fontFamily: "'Bebas Neue', cursive" }}>Check Your Email</h2>
            <p className="text-sm text-[#2A2A2A]/60 mb-4">If an account exists with <strong>{email}</strong>, we sent a reset link. Check your inbox (and spam folder).</p>
            <Link to="/login" className="pizza-btn-secondary text-sm inline-flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-[#2A2A2A]/60 mb-0.5 block" style={{ fontFamily: "'Bebas Neue', cursive" }}>Email Address</label>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                placeholder="mike@pizzapalace.com" className="pizza-input w-full" data-testid="forgot-email" />
            </div>
            {error && <p className="text-sm text-[#E23D28]">{error}</p>}
            <button type="submit" disabled={loading || !email.trim()}
              className="pizza-btn w-full disabled:opacity-50" data-testid="forgot-submit">
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            <Link to="/login" className="block text-center text-sm text-[#2A2A2A]/50 hover:text-[#E23D28]">
              <ArrowLeft className="w-3 h-3 inline mr-1" /> Back to Sign In
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
